import * as React from 'react'

export const gridHighlightBlock = () => {
  return (
    <section className="block block--linkgrid block--highlight block--color spacing--m inview">
      <div className="block__inner grid--spacing">
        <div className="block__content container container--m grid--gutter">
          <ul className="block__list grid">
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__link">
                  <div className="grid__content">
                    <header className="grid__header">
                      <span className="grid__label block__label">Lorem ipsum</span>
                      <h3 className="grid__title title--xs"><span>Donec vitae</span></h3>
                    </header>
                    <p className="grid__intro text--spacing">
                      Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo
                      sit amet risus. Cras mattis consectetur purus sit amet fermentum.
                    </p>
                  </div>
                </div>
              </article>
            </li>
            <li className="grid__item">
              <article className="grid__article">
                <a className="grid__link" href="/en/">
                  <div className="grid__content">
                    <header className="grid__header">
                      <span className="grid__label block__label">Lorem ipsum</span>
                      <h3 className="grid__title title--xs"><span>Donec vitae Pharetra Nibh Cursus Quam Condimentum</span></h3>
                    </header>
                    <p className="grid__intro text--spacing">Consectetuer adipiscing elit.</p>
                    <span className="grid__fauxlink link link--arrow">Luctus vitae</span>
                  </div>
                </a>
              </article>
            </li>
            <li className="grid__item">
              <article className="grid__article">
                <a className="grid__link" href="/en/">
                  <div className="grid__content">
                    <header className="grid__header">
                      <h3 className="grid__title title--xs"><span>Donec vitae</span></h3>
                    <p className="grid__intro text--spacing">Nullam quis risus eget urna mollis ornare vel eu leo. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </header>
                  </div>
                </a>
              </article>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}
